<app-breadcrumb [master]="'Należności'" [parentName]="'Przelewy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-transfer-details-view *ngIf="!modify" [receivablesTransfer]="receivablesTransfer" (modifyClickedEdit)="modify = true"  (modifyClicked)=" loadTransfer()"></app-transfer-details-view>
<!--    <app-terminals-details-form *ngIf="modify" [terminalsObject]="terminalsObject"-->
<!--                                (closeModification)="modify = false; loadSupport()"></app-terminals-details-form>-->
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [receivablesTransfer]="receivablesTransfer"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
